module.exports = __webpack_public_path__ + "img/recharge_benefits.92a53721.jpg";